module.exports = __webpack_public_path__ + "img/img-card-how-work-1.1fd29b24.svg";